import React from "react";
import { useGetRoomSyncFloorPlan } from "./useGetRoomSyncFloorPlan";

import { IIntegrationsMappings } from "../../services/IntegrationApi";
import { IntegrationDeleteButton } from "./IntegrationDeleteButton";
import { ModalProvider } from "../../contexts/ModalContext";
import { IntegrationEditButton } from "./IntegrationEditButton";
import useAuth from "../../routes/login/AuthContext";
import { TableCell } from "../../UI/TableCell";
import { TableRow } from "../../UI/TableRow";
import { Grid } from "../../UI/Grid";

interface IProps {
  showArchived: boolean;
}


export const IntegrationTableBodyRow: React.FC<IIntegrationsMappings & IProps> = (props) => {
  const getRoomSyncFloorPlan = useGetRoomSyncFloorPlan();
  const { isSuperAdmin } = useAuth();


  return <TableRow hover>
      <TableCell>{getRoomSyncFloorPlan(props)}</TableCell>
      <TableCell style={{ whiteSpace: "pre-wrap" }}>{props.mapping}</TableCell>
      <TableCell>{props.enableAccess ? "Yes" : "No"}</TableCell>
      <TableCell>{props.networkMappingType}</TableCell>
      <TableCell>{props.externalNetworkId}</TableCell>
      <TableCell>{props.seasonId}</TableCell>
      <TableCell>{props.grouping}</TableCell>
      {isSuperAdmin() && (
        <TableCell>
          <Grid container spacing={1} wrap="nowrap">
            <Grid item>
              <ModalProvider>
                <IntegrationDeleteButton {...props} />
              </ModalProvider>
            </Grid>
            <Grid item>
              <ModalProvider>
                <IntegrationEditButton {...props} />
              </ModalProvider>
            </Grid>
          </Grid>
        </TableCell>
      )}
    </TableRow>;
};
